import { ProductData } from 'utils/types';
import {
  StyledCoinsProduct,
  StyledTextContainer,
  StyledQuantity,
  StyledStrokeQuantity,
} from './style';

interface IMainCoinsProductProps {
  mainProduct: ProductData;
  salePercentage: number;
  isOnlyMainProduct: boolean;
}

export const MainCoinsProduct: React.FC<IMainCoinsProductProps> = ({
  mainProduct,
  salePercentage,
  isOnlyMainProduct,
}) => {
  return (
    <StyledCoinsProduct className={'hov-sub-product'}>
      <div className={'secondary-product__container'}>
        <div className={'product-img'}>
          <img src={mainProduct?.images.productPrefix} alt="product" />
        </div>

        <StyledTextContainer>
          {salePercentage > 0 && (
            <StyledStrokeQuantity
              title={mainProduct.strokedSaleQuantity}
              isStroke={true}
              className="text-container__stroked"
            >
              <div className="quantity_text">
                {mainProduct.strokedSaleQuantity}
              </div>
            </StyledStrokeQuantity>
          )}
          <StyledQuantity title={mainProduct.quantityDisplay} fontSize={16}>
            <div className="quantity_text">{mainProduct.quantityDisplay}</div>
          </StyledQuantity>
        </StyledTextContainer>
      </div>
    </StyledCoinsProduct>
  );
};
